export default "__VITE_ASSET__W5kBJt7l__"